import React from 'react';

import { FileText, Image, File } from 'lucide-react';

import { Body, EmptyPreview, PreviewImage, PreviewFrame } from './Preview.styles';

const PreviewBody = ({ file }) => {
  if (!file) return null;

  if (file.extension === 'pdf') {
    return (
      <Body>
        {file.url ? (
          <PreviewFrame title={file.name} src={file.url} />
        ) : (
          <EmptyPreview>
            <FileText size={60} />
            <h3>{file.name}</h3>
            <p>No preview available.</p>
          </EmptyPreview>
        )}
      </Body>
    );
  }

  if (['png', 'jpg', 'jpeg'].includes(file.extension)) {
    return (
      <Body>
        <PreviewImage src={file.url} alt={file.name} />
      </Body>
    );
  }

  return (
    <Body>
      <EmptyPreview>
        {file.extension === 'pdf' ? (
          <FileText size={60} />
        ) : file.extension === 'png' ? (
          <Image size={60} />
        ) : (
          <File size={60} />
        )}
        <h3>{file.name}</h3>
        <p>Preview is not available for this file type.</p>
      </EmptyPreview>
    </Body>
  );
};

export default PreviewBody;
